var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-upload',{staticClass:"upload-demo",attrs:{"action":"","before-upload":_vm.beforeUpload,"multiple":""}},[_c('el-button',{staticClass:"h-btn h-formBtn",attrs:{"size":"small","type":"primary"}},[_vm._v("点击导入")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }